// Redux reducer for KPI Dashboard

import {
    FETCH_USER_KPI_PERIODS_REQUEST,
    FETCH_USER_KPI_PERIODS_SUCCESS,
    FETCH_USER_KPI_PERIODS_FAILURE,
    FETCH_USER_KPI_DETAILS_REQUEST,
    FETCH_USER_KPI_DETAILS_SUCCESS,
    FETCH_USER_KPI_DETAILS_FAILURE
} from './redux.actions';

// Initial State
const initialState = {
    userKpiPeriods: [],
    userKpiDetails: null,
    loading: false,
    error: null
    ,
    employeePreview: [],
    employeePreviewLoading: false,
    employeePreviewError: null
};

// Reducer
const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USER_KPI_PERIODS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_USER_KPI_PERIODS_SUCCESS:
            return {
                ...state,
                userKpiPeriods: action.payload,
                loading: false,
                error: null
            };

        case FETCH_USER_KPI_PERIODS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case FETCH_USER_KPI_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_USER_KPI_DETAILS_SUCCESS:
            return {
                ...state,
                userKpiDetails: action.payload,
                loading: false,
                error: null
            };

        case FETCH_USER_KPI_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Employee Preview API
        case 'dashboard/FETCH_EMPLOYEE_PREVIEW_REQUEST':
            return {
                ...state,
                employeePreviewLoading: true,
                employeePreviewError: null
            };
        case 'dashboard/FETCH_EMPLOYEE_PREVIEW_SUCCESS':
            return {
                ...state,
                employeePreview: action.payload,
                employeePreviewLoading: false,
                employeePreviewError: null
            };
        case 'dashboard/FETCH_EMPLOYEE_PREVIEW_FAILURE':
            return {
                ...state,
                employeePreviewLoading: false,
                employeePreviewError: action.payload
            };

        default:
            return state;
    }
};

export default dashboardReducer;